import * as React from 'react';
import { Modal as Modal$2 } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const Modal = ({ isOpen , onModalClose , onHeaderButtonClick , children , labels , footer , disableHeaderButton  })=>{
    return /*#__PURE__*/ React.createElement(Modal$2, {
        className: "modal-secondary",
        isOpen: isOpen,
        onModalClose: onModalClose
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "modal-secondary__header-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "modal-secondary__header-left-section"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: onModalClose
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "modal-secondary__chevron",
        name: "chevron-left"
    })), /*#__PURE__*/ React.createElement(Heading, {
        className: "modal-secondary__title",
        variant: "smallest"
    }, labels.cta)), onHeaderButtonClick ? /*#__PURE__*/ React.createElement("button", {
        className: "modal-secondary__header-button",
        onClick: onHeaderButtonClick,
        disabled: disableHeaderButton
    }, /*#__PURE__*/ React.createElement(Text, null, labels.headerButton)) : null), children), /*#__PURE__*/ React.createElement("div", {
        className: "modal-secondary__footer"
    }, footer));
};
var Modal$1 = Modal;

export { Modal$1 as default };
//# sourceMappingURL=Modal.js.map
